export default function SectionTag({ number, label, light = false }) {
  return (
    <div data-testid={`section-tag-${number}`} className="flex items-center gap-3">
      <span className="font-mono text-xs tracking-[0.3em] text-brand-red">{number}</span>
      <span className="h-px w-10 bg-brand-red/40" />
      <span
        className={`font-mono text-xs uppercase tracking-[0.3em] ${light ? "text-slate-400" : "text-slate-500"}`}
      >
        {label}
      </span>
    </div>
  );
}
